import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { dataHas } from '../../common/ambient'
import {
  FormattedDataPoint
} from './'

export default class GaugeHeightWidget extends PureComponent {
  static propTypes = {
    currentDevice: PropTypes.object
  };

  render() {
    const { currentDevice } = this.props
    const { lastData } = currentDevice
    const data = lastData
    let widget = <div className="gaugeheight-widget hidden" />
    const currentDataHas = dataHas(data)
    if(currentDataHas('gaugeheightft')) {
      widget =
      <div className="med-number gaugeheight-widget">
        <FormattedDataPoint type={'gaugeheightft'} row={lastData} />
      </div>
    }
    return widget
  }
};
GaugeHeightWidget.displayName = 'GaugeHeightWidget'
